import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { authSelectors } from "../../../ducks/auth";
import { UserRole } from "../../../ducks/user";
import { useAuthTemplate } from "./hook";

type Props = {
  requiredLogin?: boolean;
  requiredLogout?: boolean;
  requireAdmin?: boolean;
  requireGroupAdmin?: boolean;
  children?: ReactNode;
};

export const AuthTemplate: React.FC<Props> = ({
  requiredLogin,
  requiredLogout,
  requireAdmin,
  requireGroupAdmin,
  children,
}) => {
  const {} = useAuthTemplate();
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const loggedInUser = useSelector(authSelectors.loggedInUser);

  if (isLoggedIn === null) return null;

  if (requiredLogin && !isLoggedIn) {
    return <Navigate replace to={PageRoutes.LOGIN} />;
  }

  if (requiredLogout && isLoggedIn) {
    return <Navigate replace to={PageRoutes.HOME} />;
  }

  if (requireAdmin && loggedInUser?.role !== UserRole.Admin)
    return <Navigate replace to={PageRoutes.HOME} />;

  if (requireGroupAdmin && loggedInUser?.role === UserRole.User)
    return <Navigate replace to={PageRoutes.HOME} />;

  if (!children) return <Outlet />;

  return <>{children}</>;
};
